import { render } from "./ProjectNotesStep.vue?vue&type=template&id=a5a3c556"
import script from "./ProjectNotesStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectNotesStep.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Admin/Project/ProjectNotesStep.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a5a3c556"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a5a3c556', __exports__)) {
    api.reload('a5a3c556', __exports__)
  }
  
  module.hot.accept("./ProjectNotesStep.vue?vue&type=template&id=a5a3c556", () => {
    api.rerender('a5a3c556', render)
  })

}


export default __exports__